module.exports = __webpack_public_path__ + "static/media/lu.5e532e8a.svg";